import {GoogleMapReducer, useGoogleMapReducer} from "./GoogleMap";
import React, {Context, createContext} from "react";
import {AssetsReducer, useAssetsReducer} from "./Assets";
import {FormReducer, useFormReducer} from "./Form";
import {ConfigReducer, useConfigReducer} from "./Config";

interface ContextReducer {
    googleMapReducer: GoogleMapReducer
    assetsReducer: AssetsReducer
    formReducer: FormReducer,
    configReducer: ConfigReducer,
}

export const initReducer = {
    state: {}, dispatch: (args: any) => {
    }
};
export const reducer: Context<ContextReducer> = createContext(
    {
        googleMapReducer: initReducer,
        assetsReducer: initReducer,
        formReducer: initReducer,
        configReducer: initReducer,
    }
);

const ReducerContextProvider: React.ComponentType = ({children}) => {

    const value = {
        googleMapReducer: useGoogleMapReducer(),
        assetsReducer: useAssetsReducer(),
        formReducer: useFormReducer(),
        configReducer: useConfigReducer(),
    };
    return <reducer.Provider value={value}>
        {children}
    </reducer.Provider>
};


export default ReducerContextProvider